import React from 'react';
import EventBrellaLayout from './EventBrellaLayout';

const ROWS = [
  {
    tool: 'CRM',
    elsewhere: '$30–100/month',
    eventbrella: 'Included',
    reduced: '$30–100/month',
  },
  {
    tool: 'Email & SMS',
    elsewhere: '$50–150/month combined',
    eventbrella: 'Included',
    reduced: '$50–150/month',
  },
  {
    tool: 'Ticketing',
    elsewhere: '$15–100/month subscription + 3.5–8% in platform fees per ticket',
    eventbrella: 'No software fee — ~5–6% total ticketing fee',
    reduced: 'subscription cost, plus the fee difference',
  },
  {
    tool: 'On-site ordering',
    elsewhere: '$69–165/month plus add-ons',
    eventbrella: 'Included',
    reduced: '$69–165/month',
  },
  {
    tool: 'Cross-promotion',
    elsewhere: 'No standalone tool exists — this revenue is typically lost, not just expensive',
    eventbrella: 'Included',
    reduced: "revenue that wasn't previously recoverable at any price",
  },
  {
    tool: 'Loyalty',
    elsewhere: '$45–99/month',
    eventbrella: 'Included',
    reduced: '$45–99/month',
  },
  {
    tool: 'Analytics',
    elsewhere: '$15–100/month, usually bundled into a higher ticketing-platform tier',
    eventbrella: 'Included',
    reduced: '$15–100/month',
  },
];

const TOTALS = {
  elsewhere: '$225–$570/month',
  eventbrella: '$0',
  reduced: '$225–$570/month',
};

const EventBrellaWhatYouGet = () => (
  <EventBrellaLayout>
    <section className="one-thing">
      <div className="spotlight left" />
      <div className="spotlight right" />
      <div className="wrap one-thing-inner">
        <span className="eyebrow">What You're Actually Buying</span>
        <h2>Not eight tools. One audience you own instead of rent.</h2>
      </div>
      <div className="wrap stack-list">
        <div className="stack-row stack-row-head">
          <span>Tool</span>
          <span>Elsewhere</span>
          <span>EventBrella</span>
          <span>Reduced Expenses</span>
        </div>
        {ROWS.map((row) => (
          <div className="stack-row" key={row.tool}>
            <span className="k">{row.tool}</span>
            <span className="v"><strong>Elsewhere</strong>{row.elsewhere}</span>
            <span className="v"><strong>EventBrella</strong>{row.eventbrella}</span>
            <span className="v"><strong>Reduced Expenses</strong>{row.reduced}</span>
          </div>
        ))}
        <div className="stack-row stack-row-total">
          <span className="k">Total</span>
          <span className="v"><strong>Elsewhere</strong>{TOTALS.elsewhere}</span>
          <span className="v"><strong>EventBrella</strong>{TOTALS.eventbrella}</span>
          <span className="v"><strong>Reduced Expenses</strong>{TOTALS.reduced}</span>
        </div>
      </div>
      <div className="wrap one-thing-tag">
        <p className="kicker">
          That's roughly $225–$570/month in tools alone — included at $0 with EventBrella. You only pay the reduced digital ticketing fee.
        </p>
      </div>
      <div className="wrap">
        <div className="ledger-foot">
          <span>
            Every tool on this page, free. The only line item is the ticketing fee — and it's lower than what you're paying now.
          </span>
        </div>
      </div>
    </section>
  </EventBrellaLayout>
);

export default EventBrellaWhatYouGet;
